import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    resetErrorBoundary();
    navigate('/home');
  };

  return (
    <div className="error-fallback">
      <div className="error-container">
        <h1>Oops! Something went wrong</h1>
        <p>We're sorry, but something unexpected happened.</p>
        <details>
          <summary>Error Details</summary>
          <pre>{error.message}</pre>
        </details>
        <div className="error-actions">
          <button onClick={resetErrorBoundary} className="btn-retry">
            Try Again
          </button>
          <button onClick={handleGoHome} className="btn-home">
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
